export default __webpack_public_path__ + "static/media/newspaper.310e2d70.svg";